export const vehicleProps = [
  'vin',
  'licensePlate',
  'engineType',
  'brand',
  'model',
  'equipmentType',
  'avgFuelConsumption',
  'avgFuelConsumptionWltp',
  'batteryCapacity',
  'annualAgreedKilometers',
  'annualForecastKilometers',
  'totalKm',
  'wheelSizeInch',
  'whicleSize',
  'vehicleWeight',
  'emissionCO2',
  'pollutionClass',
  'lastServiceDate',
  'nextServicePlanned',
  'fuelTankVolumeLiter',
  'monthlyServiceFee',
  'monthlyLeasingFee',
  'leasingTimeEndMonthDue',
  'calculatedValueAtDate',
  'actualValueAtDate',
  'department',
  'averageSpeed',
  'currentSpeed',
  'damages',
  'engineHours',
  'parkingHours',
];

export const propsWithUnits: Record<string, string> = {
  averageSpeed: 'km/h',
  lastRegistrationPrice: '€',
  leasingTimeEndMonthDue: 'months',
  monthlyServiceFee: '€',
  fuelTankVolumeLiter: 'l',
  monthlyLeasingFee: '€',
  calculatedValueAtDate: '€',
  actualValueAtDate: '€',
  avgFuelConsumption: 'l/100km',
  avgFuelConsumptionWltp: 'l/100km',
  wheelSizeInch: '″',
  totalKm: 'km',
  annualAgreedKilometers: 'km',
  annualForecastKilometers: 'km',
  avgFuelConsuption: 'l/100km',
  currentSpeed: 'km/h',
  coolantTemp: 'C',
  boardVoltage: 'V',
  energyLevel: '%',
  batteryCapacity: '%',
  vehicleWeight: 'kg',
  mainBatteryStatus: '%',
  backupBatteryStatus: '%',
  emissionCO2: 'g/km',
};

export const trackerProps = [
  'backupBatteryStatus',
  'imei',
  'mainBatteryStatus',
  'movementStatus',
  'msisdn',
  'trackerModel',
];
